<template>

  <el-container class="document">
    <el-header class="header">
      <div class="bg">
        <img class="three" src="../imgs/img_element_three.svg" alt=""/>
        <img class="four" src="../imgs/img_element_four.svg" alt=""/>
        <DocumentHeader title="开放平台API文档中心"/>
        <FullSearch style="margin-top: 50px"
                    v-model="keyword"
                    docType="2"
                    @search="getSearchList"/>
      </div>

    </el-header>
    <router-view></router-view>
  </el-container>
</template>

<script>
  import DocumentHeader from '../DocumentHeader'
  import FullSearch from '../FullSearch'
  import apis from "@/api/apis";


  export default {
    name: "document",
    components: {DocumentHeader, FullSearch},
    mounted() {
      this.getCate()
    },
    data(){
      return{
        keyword:''
      }
    },
    methods: {
      getSearchList(){
        this.$router.push({
          name:'search',
          params: {keyword:this.keyword,docType:'2'} //1=文档，2=API，3=公告
        })
      },
      getCate() {
        const cateId = this.$route.params.cateId
        if (!cateId) {
          apis.apiDocument.getCate().then(res => {
            this.cateList = res.data
            if (this.cateList && this.cateList.length) {
              this.$router.push(`/apiDocument/${this.cateList[0].id}`)
            }
          })
        }
      },
    },
    watch:{
      '$route.path'(value){
        // 在公告子路由的时候，点击头部的平台公告，只有路由刷新，组件不会重新加载，手动重置数据
        if(value === '/apiDocument') {
          this.getCate()
        }
      }
    }
  }
</script>
<style scoped lang="scss">

  .document {
    min-height: 100%;
    background: #FAFAFA;

    .header {
      height: 300px !important;
      background: linear-gradient(180deg, #FFFFFF 0%, #F2F5FA 100%);
      margin-bottom: 16px;
      padding: 47px 0 0;
      position: relative;

      .bg {
        width: 1280px;
        height: 100%;
        margin: 0 auto;
        position: relative;

        img {
          width: 287px;
          height: 82px;
          position: absolute;
          z-index: 9;

          &.three {
            left: 100px;
            top: 50px;
          }

          &.four {
            right: 100px;
            top: 50px;
          }
        }
      }
    }

  }

</style>
